module.exports = __webpack_public_path__ + "static/img/yl-1.fa83f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/yl-1.png
// module id = mcyo
// module chunks = 14